// ----------------------------------------------------------------------
// <copyright file="Izenda.TenantDetailModules.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Tenant Detail Modules
 */
!(function () {

  var React = require('react');
  var Input = require('share/components/controls/Izenda.Input');
  var connect = require('share/enhancers/Izenda.Connect');

  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  var EventUtils = require('EventUtils');

  const { chunk } = require('lodash/fp');

  var TenantDetailModules = function (props) {

    var localization = props.localization;
    var store = props.store;
    var allModules = store.modulesOfLicense || [];
    var disabled = !store.showingTenantCloned.active;
    var showingTenant = store.showingTenantCloned;

    return (
        <fieldset disabled={disabled} >
          <label className="u-posAbsolute">{localization.getText('TENANT_DETAIL_MODULES_LABEL_MODULES')}</label>
          <GridLayout className="Izenda-TenantDetail_GridModule">
            { chunk(3, allModules).map(renderModules)}
          </GridLayout>
        </fieldset>
    );


    function renderModules(modules, index) {
      return (
          <GridLayout.Row key={index}>
            {modules.map(renderModule)}
          </GridLayout.Row>
      );

      function renderModule (module, index) {
        var checked = !!showingTenant.hasModule(module);
        return (
            <GridLayout.Col cols={4} key={index}>
              <label>
                <Input
                  type='checkbox'
                  checked={checked}
                  onChange={EventUtils.notifyChange(showingTenant.updateModules.bind(showingTenant, module), EventUtils.CHECKBOX)}/>
                <span>{module.name}</span>
              </label>
            </GridLayout.Col>
        );
      }
    }

  };

  TenantDetailModules.propTypes = {
    store: React.PropTypes.object.isRequired
  };

  module.exports = connect()(TenantDetailModules);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/TenantManagement/Izenda.TenantDetailModules.jsx